/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AuthedRouteImport } from "./routes/_authed"
import { Route as AuthedIndexRouteImport } from "./routes/_authed/index"
import { Route as McpAuthorizeRouteImport } from "./routes/mcp.authorize"
import { Route as InviteTokenRouteImport } from "./routes/invite.$token"
import { Route as DesktopCalendarRouteImport } from "./routes/desktop.calendar"
import { Route as DesktopAuthorizeRouteImport } from "./routes/desktop.authorize"
import { Route as DesktopAccountRouteImport } from "./routes/desktop.account"
import { Route as AuthVerifyEmailRouteImport } from "./routes/auth.verify-email"
import { Route as AuthVerifyRouteImport } from "./routes/auth.verify"
import { Route as AuthSignUpRouteImport } from "./routes/auth.sign-up"
import { Route as AuthSignInRouteImport } from "./routes/auth.sign-in"
import { Route as AuthResetPasswordRouteImport } from "./routes/auth.reset-password"
import { Route as AuthForgotPasswordRouteImport } from "./routes/auth.forgot-password"
import { Route as AuthedSpacesRouteImport } from "./routes/_authed/spaces"
import { Route as AuthedSettingsRouteImport } from "./routes/_authed/settings"
import { Route as AuthedOnboardingRouteImport } from "./routes/_authed/onboarding"
import { Route as AuthedLibraryRouteImport } from "./routes/_authed/library"
import { Route as AuthedArchivedRouteImport } from "./routes/_authed/archived"
import { Route as AuthedMeetingsIndexRouteImport } from "./routes/_authed/meetings/index"
import { Route as AuthedSettingsSecurityRouteImport } from "./routes/_authed/settings.security"
import { Route as AuthedSettingsNotificationsRouteImport } from "./routes/_authed/settings.notifications"
import { Route as AuthedSettingsIntegrationsRouteImport } from "./routes/_authed/settings.integrations"
import { Route as AuthedSettingsGeneralRouteImport } from "./routes/_authed/settings.general"
import { Route as AuthedSettingsAccountRouteImport } from "./routes/_authed/settings.account"
import { Route as AuthedOnboardingLanguageRouteImport } from "./routes/_authed/onboarding/language"
import { Route as AuthedOnboardingFirstMeetingRouteImport } from "./routes/_authed/onboarding/first-meeting"
import { Route as AuthedOnboardingChannelsRouteImport } from "./routes/_authed/onboarding/channels"
import { Route as AuthedMeetingsNewRouteImport } from "./routes/_authed/meetings/new"
import { Route as AuthedMeetingsIdRouteImport } from "./routes/_authed/meetings.$id"

const AuthedRoute = AuthedRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AuthedRoute,
} as any)
const McpAuthorizeRoute = McpAuthorizeRouteImport.update({
  id: "/mcp/authorize",
  path: "/mcp/authorize",
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: "/invite/$token",
  path: "/invite/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopCalendarRoute = DesktopCalendarRouteImport.update({
  id: "/desktop/calendar",
  path: "/desktop/calendar",
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopAuthorizeRoute = DesktopAuthorizeRouteImport.update({
  id: "/desktop/authorize",
  path: "/desktop/authorize",
  getParentRoute: () => rootRouteImport,
} as any)
const DesktopAccountRoute = DesktopAccountRouteImport.update({
  id: "/desktop/account",
  path: "/desktop/account",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: "/auth/verify-email",
  path: "/auth/verify-email",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: "/auth/verify",
  path: "/auth/verify",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: "/auth/sign-up",
  path: "/auth/sign-up",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: "/auth/sign-in",
  path: "/auth/sign-in",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: "/auth/reset-password",
  path: "/auth/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: "/auth/forgot-password",
  path: "/auth/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedSpacesRoute = AuthedSpacesRouteImport.update({
  id: "/spaces",
  path: "/spaces",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOnboardingRoute = AuthedOnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLibraryRoute = AuthedLibraryRouteImport.update({
  id: "/library",
  path: "/library",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedArchivedRoute = AuthedArchivedRouteImport.update({
  id: "/archived",
  path: "/archived",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeetingsIndexRoute = AuthedMeetingsIndexRouteImport.update({
  id: "/meetings/",
  path: "/meetings/",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsSecurityRoute = AuthedSettingsSecurityRouteImport.update({
  id: "/security",
  path: "/security",
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedSettingsNotificationsRoute =
  AuthedSettingsNotificationsRouteImport.update({
    id: "/notifications",
    path: "/notifications",
    getParentRoute: () => AuthedSettingsRoute,
  } as any)
const AuthedSettingsIntegrationsRoute =
  AuthedSettingsIntegrationsRouteImport.update({
    id: "/integrations",
    path: "/integrations",
    getParentRoute: () => AuthedSettingsRoute,
  } as any)
const AuthedSettingsGeneralRoute = AuthedSettingsGeneralRouteImport.update({
  id: "/general",
  path: "/general",
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedSettingsAccountRoute = AuthedSettingsAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => AuthedSettingsRoute,
} as any)
const AuthedOnboardingLanguageRoute =
  AuthedOnboardingLanguageRouteImport.update({
    id: "/language",
    path: "/language",
    getParentRoute: () => AuthedOnboardingRoute,
  } as any)
const AuthedOnboardingFirstMeetingRoute =
  AuthedOnboardingFirstMeetingRouteImport.update({
    id: "/first-meeting",
    path: "/first-meeting",
    getParentRoute: () => AuthedOnboardingRoute,
  } as any)
const AuthedOnboardingChannelsRoute =
  AuthedOnboardingChannelsRouteImport.update({
    id: "/channels",
    path: "/channels",
    getParentRoute: () => AuthedOnboardingRoute,
  } as any)
const AuthedMeetingsNewRoute = AuthedMeetingsNewRouteImport.update({
  id: "/meetings/new",
  path: "/meetings/new",
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMeetingsIdRoute = AuthedMeetingsIdRouteImport.update({
  id: "/meetings/$id",
  path: "/meetings/$id",
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof AuthedIndexRoute
  "/archived": typeof AuthedArchivedRoute
  "/library": typeof AuthedLibraryRoute
  "/onboarding": typeof AuthedOnboardingRouteWithChildren
  "/settings": typeof AuthedSettingsRouteWithChildren
  "/spaces": typeof AuthedSpacesRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/sign-in": typeof AuthSignInRoute
  "/auth/sign-up": typeof AuthSignUpRoute
  "/auth/verify": typeof AuthVerifyRoute
  "/auth/verify-email": typeof AuthVerifyEmailRoute
  "/desktop/account": typeof DesktopAccountRoute
  "/desktop/authorize": typeof DesktopAuthorizeRoute
  "/desktop/calendar": typeof DesktopCalendarRoute
  "/invite/$token": typeof InviteTokenRoute
  "/mcp/authorize": typeof McpAuthorizeRoute
  "/meetings/$id": typeof AuthedMeetingsIdRoute
  "/meetings/new": typeof AuthedMeetingsNewRoute
  "/onboarding/channels": typeof AuthedOnboardingChannelsRoute
  "/onboarding/first-meeting": typeof AuthedOnboardingFirstMeetingRoute
  "/onboarding/language": typeof AuthedOnboardingLanguageRoute
  "/settings/account": typeof AuthedSettingsAccountRoute
  "/settings/general": typeof AuthedSettingsGeneralRoute
  "/settings/integrations": typeof AuthedSettingsIntegrationsRoute
  "/settings/notifications": typeof AuthedSettingsNotificationsRoute
  "/settings/security": typeof AuthedSettingsSecurityRoute
  "/meetings/": typeof AuthedMeetingsIndexRoute
}
export interface FileRoutesByTo {
  "/archived": typeof AuthedArchivedRoute
  "/library": typeof AuthedLibraryRoute
  "/onboarding": typeof AuthedOnboardingRouteWithChildren
  "/settings": typeof AuthedSettingsRouteWithChildren
  "/spaces": typeof AuthedSpacesRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/sign-in": typeof AuthSignInRoute
  "/auth/sign-up": typeof AuthSignUpRoute
  "/auth/verify": typeof AuthVerifyRoute
  "/auth/verify-email": typeof AuthVerifyEmailRoute
  "/desktop/account": typeof DesktopAccountRoute
  "/desktop/authorize": typeof DesktopAuthorizeRoute
  "/desktop/calendar": typeof DesktopCalendarRoute
  "/invite/$token": typeof InviteTokenRoute
  "/mcp/authorize": typeof McpAuthorizeRoute
  "/": typeof AuthedIndexRoute
  "/meetings/$id": typeof AuthedMeetingsIdRoute
  "/meetings/new": typeof AuthedMeetingsNewRoute
  "/onboarding/channels": typeof AuthedOnboardingChannelsRoute
  "/onboarding/first-meeting": typeof AuthedOnboardingFirstMeetingRoute
  "/onboarding/language": typeof AuthedOnboardingLanguageRoute
  "/settings/account": typeof AuthedSettingsAccountRoute
  "/settings/general": typeof AuthedSettingsGeneralRoute
  "/settings/integrations": typeof AuthedSettingsIntegrationsRoute
  "/settings/notifications": typeof AuthedSettingsNotificationsRoute
  "/settings/security": typeof AuthedSettingsSecurityRoute
  "/meetings": typeof AuthedMeetingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_authed": typeof AuthedRouteWithChildren
  "/_authed/archived": typeof AuthedArchivedRoute
  "/_authed/library": typeof AuthedLibraryRoute
  "/_authed/onboarding": typeof AuthedOnboardingRouteWithChildren
  "/_authed/settings": typeof AuthedSettingsRouteWithChildren
  "/_authed/spaces": typeof AuthedSpacesRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/sign-in": typeof AuthSignInRoute
  "/auth/sign-up": typeof AuthSignUpRoute
  "/auth/verify": typeof AuthVerifyRoute
  "/auth/verify-email": typeof AuthVerifyEmailRoute
  "/desktop/account": typeof DesktopAccountRoute
  "/desktop/authorize": typeof DesktopAuthorizeRoute
  "/desktop/calendar": typeof DesktopCalendarRoute
  "/invite/$token": typeof InviteTokenRoute
  "/mcp/authorize": typeof McpAuthorizeRoute
  "/_authed/": typeof AuthedIndexRoute
  "/_authed/meetings/$id": typeof AuthedMeetingsIdRoute
  "/_authed/meetings/new": typeof AuthedMeetingsNewRoute
  "/_authed/onboarding/channels": typeof AuthedOnboardingChannelsRoute
  "/_authed/onboarding/first-meeting": typeof AuthedOnboardingFirstMeetingRoute
  "/_authed/onboarding/language": typeof AuthedOnboardingLanguageRoute
  "/_authed/settings/account": typeof AuthedSettingsAccountRoute
  "/_authed/settings/general": typeof AuthedSettingsGeneralRoute
  "/_authed/settings/integrations": typeof AuthedSettingsIntegrationsRoute
  "/_authed/settings/notifications": typeof AuthedSettingsNotificationsRoute
  "/_authed/settings/security": typeof AuthedSettingsSecurityRoute
  "/_authed/meetings/": typeof AuthedMeetingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/archived"
    | "/library"
    | "/onboarding"
    | "/settings"
    | "/spaces"
    | "/auth/forgot-password"
    | "/auth/reset-password"
    | "/auth/sign-in"
    | "/auth/sign-up"
    | "/auth/verify"
    | "/auth/verify-email"
    | "/desktop/account"
    | "/desktop/authorize"
    | "/desktop/calendar"
    | "/invite/$token"
    | "/mcp/authorize"
    | "/meetings/$id"
    | "/meetings/new"
    | "/onboarding/channels"
    | "/onboarding/first-meeting"
    | "/onboarding/language"
    | "/settings/account"
    | "/settings/general"
    | "/settings/integrations"
    | "/settings/notifications"
    | "/settings/security"
    | "/meetings/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/archived"
    | "/library"
    | "/onboarding"
    | "/settings"
    | "/spaces"
    | "/auth/forgot-password"
    | "/auth/reset-password"
    | "/auth/sign-in"
    | "/auth/sign-up"
    | "/auth/verify"
    | "/auth/verify-email"
    | "/desktop/account"
    | "/desktop/authorize"
    | "/desktop/calendar"
    | "/invite/$token"
    | "/mcp/authorize"
    | "/"
    | "/meetings/$id"
    | "/meetings/new"
    | "/onboarding/channels"
    | "/onboarding/first-meeting"
    | "/onboarding/language"
    | "/settings/account"
    | "/settings/general"
    | "/settings/integrations"
    | "/settings/notifications"
    | "/settings/security"
    | "/meetings"
  id:
    | "__root__"
    | "/_authed"
    | "/_authed/archived"
    | "/_authed/library"
    | "/_authed/onboarding"
    | "/_authed/settings"
    | "/_authed/spaces"
    | "/auth/forgot-password"
    | "/auth/reset-password"
    | "/auth/sign-in"
    | "/auth/sign-up"
    | "/auth/verify"
    | "/auth/verify-email"
    | "/desktop/account"
    | "/desktop/authorize"
    | "/desktop/calendar"
    | "/invite/$token"
    | "/mcp/authorize"
    | "/_authed/"
    | "/_authed/meetings/$id"
    | "/_authed/meetings/new"
    | "/_authed/onboarding/channels"
    | "/_authed/onboarding/first-meeting"
    | "/_authed/onboarding/language"
    | "/_authed/settings/account"
    | "/_authed/settings/general"
    | "/_authed/settings/integrations"
    | "/_authed/settings/notifications"
    | "/_authed/settings/security"
    | "/_authed/meetings/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  DesktopAccountRoute: typeof DesktopAccountRoute
  DesktopAuthorizeRoute: typeof DesktopAuthorizeRoute
  DesktopCalendarRoute: typeof DesktopCalendarRoute
  InviteTokenRoute: typeof InviteTokenRoute
  McpAuthorizeRoute: typeof McpAuthorizeRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_authed": {
      id: "/_authed"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/": {
      id: "/_authed/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/mcp/authorize": {
      id: "/mcp/authorize"
      path: "/mcp/authorize"
      fullPath: "/mcp/authorize"
      preLoaderRoute: typeof McpAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invite/$token": {
      id: "/invite/$token"
      path: "/invite/$token"
      fullPath: "/invite/$token"
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/desktop/calendar": {
      id: "/desktop/calendar"
      path: "/desktop/calendar"
      fullPath: "/desktop/calendar"
      preLoaderRoute: typeof DesktopCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/desktop/authorize": {
      id: "/desktop/authorize"
      path: "/desktop/authorize"
      fullPath: "/desktop/authorize"
      preLoaderRoute: typeof DesktopAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/desktop/account": {
      id: "/desktop/account"
      path: "/desktop/account"
      fullPath: "/desktop/account"
      preLoaderRoute: typeof DesktopAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/verify-email": {
      id: "/auth/verify-email"
      path: "/auth/verify-email"
      fullPath: "/auth/verify-email"
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/verify": {
      id: "/auth/verify"
      path: "/auth/verify"
      fullPath: "/auth/verify"
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/sign-up": {
      id: "/auth/sign-up"
      path: "/auth/sign-up"
      fullPath: "/auth/sign-up"
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/sign-in": {
      id: "/auth/sign-in"
      path: "/auth/sign-in"
      fullPath: "/auth/sign-in"
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/reset-password": {
      id: "/auth/reset-password"
      path: "/auth/reset-password"
      fullPath: "/auth/reset-password"
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/forgot-password": {
      id: "/auth/forgot-password"
      path: "/auth/forgot-password"
      fullPath: "/auth/forgot-password"
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed/spaces": {
      id: "/_authed/spaces"
      path: "/spaces"
      fullPath: "/spaces"
      preLoaderRoute: typeof AuthedSpacesRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/settings": {
      id: "/_authed/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/onboarding": {
      id: "/_authed/onboarding"
      path: "/onboarding"
      fullPath: "/onboarding"
      preLoaderRoute: typeof AuthedOnboardingRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/library": {
      id: "/_authed/library"
      path: "/library"
      fullPath: "/library"
      preLoaderRoute: typeof AuthedLibraryRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/archived": {
      id: "/_authed/archived"
      path: "/archived"
      fullPath: "/archived"
      preLoaderRoute: typeof AuthedArchivedRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/meetings/": {
      id: "/_authed/meetings/"
      path: "/meetings"
      fullPath: "/meetings/"
      preLoaderRoute: typeof AuthedMeetingsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/settings/security": {
      id: "/_authed/settings/security"
      path: "/security"
      fullPath: "/settings/security"
      preLoaderRoute: typeof AuthedSettingsSecurityRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    "/_authed/settings/notifications": {
      id: "/_authed/settings/notifications"
      path: "/notifications"
      fullPath: "/settings/notifications"
      preLoaderRoute: typeof AuthedSettingsNotificationsRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    "/_authed/settings/integrations": {
      id: "/_authed/settings/integrations"
      path: "/integrations"
      fullPath: "/settings/integrations"
      preLoaderRoute: typeof AuthedSettingsIntegrationsRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    "/_authed/settings/general": {
      id: "/_authed/settings/general"
      path: "/general"
      fullPath: "/settings/general"
      preLoaderRoute: typeof AuthedSettingsGeneralRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    "/_authed/settings/account": {
      id: "/_authed/settings/account"
      path: "/account"
      fullPath: "/settings/account"
      preLoaderRoute: typeof AuthedSettingsAccountRouteImport
      parentRoute: typeof AuthedSettingsRoute
    }
    "/_authed/onboarding/language": {
      id: "/_authed/onboarding/language"
      path: "/language"
      fullPath: "/onboarding/language"
      preLoaderRoute: typeof AuthedOnboardingLanguageRouteImport
      parentRoute: typeof AuthedOnboardingRoute
    }
    "/_authed/onboarding/first-meeting": {
      id: "/_authed/onboarding/first-meeting"
      path: "/first-meeting"
      fullPath: "/onboarding/first-meeting"
      preLoaderRoute: typeof AuthedOnboardingFirstMeetingRouteImport
      parentRoute: typeof AuthedOnboardingRoute
    }
    "/_authed/onboarding/channels": {
      id: "/_authed/onboarding/channels"
      path: "/channels"
      fullPath: "/onboarding/channels"
      preLoaderRoute: typeof AuthedOnboardingChannelsRouteImport
      parentRoute: typeof AuthedOnboardingRoute
    }
    "/_authed/meetings/new": {
      id: "/_authed/meetings/new"
      path: "/meetings/new"
      fullPath: "/meetings/new"
      preLoaderRoute: typeof AuthedMeetingsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    "/_authed/meetings/$id": {
      id: "/_authed/meetings/$id"
      path: "/meetings/$id"
      fullPath: "/meetings/$id"
      preLoaderRoute: typeof AuthedMeetingsIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedOnboardingRouteChildren {
  AuthedOnboardingChannelsRoute: typeof AuthedOnboardingChannelsRoute
  AuthedOnboardingFirstMeetingRoute: typeof AuthedOnboardingFirstMeetingRoute
  AuthedOnboardingLanguageRoute: typeof AuthedOnboardingLanguageRoute
}

const AuthedOnboardingRouteChildren: AuthedOnboardingRouteChildren = {
  AuthedOnboardingChannelsRoute: AuthedOnboardingChannelsRoute,
  AuthedOnboardingFirstMeetingRoute: AuthedOnboardingFirstMeetingRoute,
  AuthedOnboardingLanguageRoute: AuthedOnboardingLanguageRoute,
}

const AuthedOnboardingRouteWithChildren =
  AuthedOnboardingRoute._addFileChildren(AuthedOnboardingRouteChildren)

interface AuthedSettingsRouteChildren {
  AuthedSettingsAccountRoute: typeof AuthedSettingsAccountRoute
  AuthedSettingsGeneralRoute: typeof AuthedSettingsGeneralRoute
  AuthedSettingsIntegrationsRoute: typeof AuthedSettingsIntegrationsRoute
  AuthedSettingsNotificationsRoute: typeof AuthedSettingsNotificationsRoute
  AuthedSettingsSecurityRoute: typeof AuthedSettingsSecurityRoute
}

const AuthedSettingsRouteChildren: AuthedSettingsRouteChildren = {
  AuthedSettingsAccountRoute: AuthedSettingsAccountRoute,
  AuthedSettingsGeneralRoute: AuthedSettingsGeneralRoute,
  AuthedSettingsIntegrationsRoute: AuthedSettingsIntegrationsRoute,
  AuthedSettingsNotificationsRoute: AuthedSettingsNotificationsRoute,
  AuthedSettingsSecurityRoute: AuthedSettingsSecurityRoute,
}

const AuthedSettingsRouteWithChildren = AuthedSettingsRoute._addFileChildren(
  AuthedSettingsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedArchivedRoute: typeof AuthedArchivedRoute
  AuthedLibraryRoute: typeof AuthedLibraryRoute
  AuthedOnboardingRoute: typeof AuthedOnboardingRouteWithChildren
  AuthedSettingsRoute: typeof AuthedSettingsRouteWithChildren
  AuthedSpacesRoute: typeof AuthedSpacesRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedMeetingsIdRoute: typeof AuthedMeetingsIdRoute
  AuthedMeetingsNewRoute: typeof AuthedMeetingsNewRoute
  AuthedMeetingsIndexRoute: typeof AuthedMeetingsIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedArchivedRoute: AuthedArchivedRoute,
  AuthedLibraryRoute: AuthedLibraryRoute,
  AuthedOnboardingRoute: AuthedOnboardingRouteWithChildren,
  AuthedSettingsRoute: AuthedSettingsRouteWithChildren,
  AuthedSpacesRoute: AuthedSpacesRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedMeetingsIdRoute: AuthedMeetingsIdRoute,
  AuthedMeetingsNewRoute: AuthedMeetingsNewRoute,
  AuthedMeetingsIndexRoute: AuthedMeetingsIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  DesktopAccountRoute: DesktopAccountRoute,
  DesktopAuthorizeRoute: DesktopAuthorizeRoute,
  DesktopCalendarRoute: DesktopCalendarRoute,
  InviteTokenRoute: InviteTokenRoute,
  McpAuthorizeRoute: McpAuthorizeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
